import React, { Component } from "react";
import {
  Icon,
  Modal,
  Button,
  Form,
  Input,
  Segment,
  TextArea,
  Popup,
} from "semantic-ui-react";

// import { init, send } from 'emailjs-com';
import axios from "axios";
import { getEnrollmentSchoolYear, formatSchoolYear } from "../../utils/quarterUtils";
// init('user_gx0Jid2obrg3E1RLZDMBo');

const currencyFormatter = new Intl.NumberFormat();

class ApplicantsSendEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      to: "",
      subject: "",
      message: "",
    };
  }
  closeModal = () => this.setState({ showModal: false });

  openModal = () => this.setState({ showModal: true });

  onSubmit = (e) => {
    e.preventDefault();

    // const toSend = {
    //   from_name: this.state.from_name,
    //   to_name: this.state.to_name,
    //   message: this.state.message,
    //   reply_to: this.state.reply_to,
    // }

    // const data = {
    //   service_id: 'service_2mvznnk',
    //   template_id: 'template_z1xdp1c',
    //   user_id: 'user_gx0Jid2obrg3E1RLZDMBo',
    //   template_params: toSend,
    //   access_token: '35a36c7638fce726ad3efb76ba2706a9'
    // };
    //   send(
    //     'service_2mvznnk',
    //     'template_z1xdp1c',
    //     toSend,
    //     'user_gx0Jid2obrg3E1RLZDMBo',
    //     '35a36c7638fce726ad3efb76ba2706a9'
    //   )
    //     .then((response) => {
    //       console.log('SUCCESS!', response.status, response.text);
    //       alert('Sent!');
    //     })
    //     .catch((err) => {
    //       console.log('FAILED...', err);
    //     });
    const data = {
      to: this.state.to,
      subject: this.state.subject,
      message: this.state.message,
    };
    axios
      .request({
        method: "post",
        url: process.env.REACT_APP_URL + "/applicants/sendEmail",
        data: data,
      })
      .then((response) => {
        alert(`Email sent!`);
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert("Error. Please contact your administrator for assistance.");
        }
      });

    axios
      .request({
        method: "put",
        url:
          process.env.REACT_APP_URL +
          "/applicants/" +
          this.props.applicant.applicantId,
        data: { sentEmail: true },
      })
      .then((response) => {
        this.props.getApplicants();
        alert(`Check the school's email address for confirmation.`);
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert("Error. Please contact your administrator for assistance.");
        }
      });
    this.closeModal();
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  updateState = (applicant) => {
    let subject = "SALIS Enrollment",
      message = "",
      paymentOptionMessage = "";
    const schoolYearLabel = formatSchoolYear(getEnrollmentSchoolYear());
    const applicantName = `${applicant.lastName}, ${applicant.firstName}`;
    const ue =
      applicant.toPayUponEnrollment === "--"
        ? "--"
        : currencyFormatter.format(applicant.toPayUponEnrollment);
    const amount =
      applicant.amount === "--"
        ? "--"
        : currencyFormatter.format(applicant.amount);
    const balance =
      applicant.unsettledBalance === "--"
        ? "--"
        : currencyFormatter.format(applicant.unsettledBalance);
    if (applicant.applicationType === "new") {
      subject = `SALIS Enrollment for ${applicantName} (New Student)`;
    } else {
      subject = `SALIS Enrollment for ${applicantName} (Old Student)`;
    }

    if (applicant.paymentSchedule === "Full Cash Basis") {
      paymentOptionMessage = `you selected to pay in full cash upon enrollment with a total amount of ${ue}.`;
    } else if (applicant.paymentSchedule === "Semi-Annual") {
      paymentOptionMessage = `you selected to pay semi-annually. You need to pay ${ue} upon enrollment.`;
    } else if (applicant.paymentSchedule === "Quarterly") {
      paymentOptionMessage = `you selected to pay quarterly. You need to pay ${ue} upon enrollment.`;
    } else {
      paymentOptionMessage = `you selected to pay monthly. You need to pay ${ue} upon enrollment and pay ${amount} monthly for the remaining months.`;
    }

    if (applicant.clearToEnroll === "Ok") {
      if (applicant.applicationType === "new") {
        if (applicant.withOtherGrants && applicant.withESCSubsidy) {
          message = `
            Good day!

            Thank you for communicating with us. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} ESC Subsidy and other grant computation have been already applied. If you have pending subsidies or grants, recomputation will follow.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you and welcome to the Liguorian family!


            SALIS Enrollment Team
            `;
        } else if (applicant.withOtherGrants && applicant.withSHSVoucher) {
          message = `
            Good day!

            Thank you for communicating with us. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} SHS Voucher and other grant computation have been already applied. If you have pending subsidies or grants, recomputation will follow.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you and welcome to the Liguorian family!


            SALIS Enrollment Team
            `;
        } else if (applicant.withESCSubsidy) {
          message = `
            Good day!

            Thank you for communicating with us. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} ESC subsidy is already applied. If you have pending subsidies or grants, recomputation will follow.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you and welcome to the Liguorian family!


            SALIS Enrollment Team
            `;
        } else if (applicant.withSHSVoucher) {
          message = `
            Good day!

            Thank you for communicating with us. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} SHS Voucher is already applied. If you have pending subsidies or grants, recomputation will follow.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you and welcome to the Liguorian family!


            SALIS Enrollment Team
            `;
        } else {
          message = `
            Good day!

            Thank you for communicating with us. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} If you have pending subsidies or grants, recomputation will be applied.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you and welcome to the Liguorian family!


            SALIS Enrollment Team
            `;
        }
      } else {
        if (applicant.withOtherGrants && applicant.withESCSubsidy) {
          message = `
            Good day!

            Thank you for communicating with us. Upon checking, you have no deficiencies from the previous school year for ${applicantName}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} ESC Subsidy and other grant computation have been already applied. If you have pending subsidies or grants, recomputation will follow.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


            SALIS Enrollment Team
            `;
        } else if (applicant.withOtherGrants && applicant.withSHSVoucher) {
          message = `
            Good day!

            Thank you for communicating with us. Upon checking, you have no deficiencies from the previous school year for ${applicantName}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} SHS Voucher and other grant computation have been already applied. If you have pending subsidies or grants, recomputation will follow.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


            SALIS Enrollment Team
            `;
        } else if (applicant.withESCSubsidy) {
          message = `
            Good day!

            Thank you for communicating with us. Upon checking, you have no deficiencies from the previous school year for ${applicantName}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} ESC subsidy is already applied. If you have pending subsidies or grants, recomputation will follow.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


            SALIS Enrollment Team
            `;
        } else if (applicant.withSHSVoucher) {
          message = `
            Good day!

            Thank you for communicating with us. Upon checking, you have no deficiencies from the previous school year for ${applicantName}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} SHS Voucher is already applied. If you have pending subsidies or grants, recomputation will follow.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


            SALIS Enrollment Team
            `;
        } else {
          message = `
            Good day!

            Thank you for communicating with us. Upon checking, you have no deficiencies from the previous school year for ${applicantName}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage}
            If you have pending subsidies or grants, recomputation will be applied.

            For payment, please deposit it to the school’s account:

            Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
            Account Number: 392-7-392500550

            Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

            If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


            SALIS Enrollment Team
            `;
        }
      }
    } else if (applicant.clearToEnroll === "Temp") {
      if (applicant.withOtherGrants && applicant.withESCSubsidy) {
        message = `
          Good day!

          Thank you for communicating with us. Upon checking, you still have an unsettled balance from the previous school year for ${applicantName} amounting to ${balance}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} ESC Subsidy and other grant computation have been already applied. If you have pending subsidies or grants, recomputation will follow.

          For payment, please deposit it to the school’s account:

          Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
          Account Number: 392-7-392500550

          Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

          If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


          SALIS Enrollment Team
          `;
      } else if (applicant.withOtherGrants && applicant.withSHSVoucher) {
        message = `
          Good day!

          Thank you for communicating with us. Upon checking, you still have an unsettled balance from the previous school year for ${applicantName} amounting to ${balance}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} SHS Voucher and other grant computation have been already applied. If you have pending subsidies or grants, recomputation will follow.

          For payment, please deposit it to the school’s account:

          Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
          Account Number: 392-7-392500550

          Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

          If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


          SALIS Enrollment Team
          `;
      } else if (applicant.withESCSubsidy) {
        message = `
          Good day!

          Thank you for communicating with us. Upon checking, you still have an unsettled balance from the previous school year for ${applicantName} amounting to ${balance}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} ESC Subsidy is already applied. If you have pending subsidies or grants, recomputation will follow.

          For payment, please deposit it to the school’s account:

          Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
          Account Number: 392-7-392500550

          Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

          If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


          SALIS Enrollment Team
          `;
      } else if (applicant.withSHSVoucher) {
        message = `
          Good day!

          Thank you for communicating with us. Upon checking, you still have an unsettled balance from the previous school year for ${applicantName} amounting to ${balance}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage} SHS Voucher is already applied. If you have pending subsidies or grants, recomputation will follow.

          For payment, please deposit it to the school’s account:

          Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
          Account Number: 392-7-392500550

          Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

          If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


          SALIS Enrollment Team
          `;
      } else {
        message = `
          Good day!

          Thank you for communicating with us. Upon checking, you still have an unsettled balance from the previous school year for ${applicantName} amounting to ${balance}. For the upcoming ${schoolYearLabel}, ${paymentOptionMessage}
          If you have pending subsidies or grants, recomputation will follow.

          For payment, please deposit it to the school’s account:

          Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
          Account Number: 392-7-392500550

          Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

          If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


          SALIS Enrollment Team
          `;
      }
    } else if (applicant.clearToEnroll === "Not Ok") {
      message = `
        Good day!

        Thank you for communicating with us. Upon checking, you still have an unsettled balance from the previous school year for ${applicantName} amounting to ${balance}. Please settle your balance first. For payment, please deposit it to the school’s account:

        Account Name: ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL METROBANK-MOLINO, BACOOR
        Account Number: 392-7-392500550

        Upon payment, please send us a copy of the deposit slip or transaction slip to enrollment@salisonline.com.

        If payment has already been made, please disregard this message. Thank you for choosing and staying with SALIS!


        SALIS Enrollment Team
        `;
    } else {
      message = `
        Good day!

        Thank you for communicating with us. For further inquiries you can email us at enrollment@salisonline.com.

        SALIS Enrollment Team
        `;
    }
    this.setState({ to: applicant.email, subject, message });
  };

  componentDidMount = () => {
    this.updateState(this.props.applicant);
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      JSON.stringify(prevProps.applicant) !==
      JSON.stringify(this.props.applicant)
    ) {
      this.updateState(this.props.applicant);
    }
  };

  render() {
    return (
      <Modal
        trigger={
          <Popup
            on="hover"
            position="bottom center"
            size="tiny"
            trigger={
              <Button
                icon
                size="tiny"
                disabled={this.props.applicant.sentEmail}
                onClick={this.openModal}
              >
                <Icon name="mail" />
              </Button>
            }
          >
            Send Tuition Assessment Email
          </Popup>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
      >
        <Modal.Header>Send Email</Modal.Header>
        <Modal.Content>
          <Segment>
            <Form onSubmit={this.onSubmit}>
              <Form.Field
                control={Input}
                value={this.state.to}
                name="to"
                label="To"
                placeholder="Email"
                onChange={this.handleChange}
              />
              <Form.Field
                control={Input}
                value={this.state.subject}
                name="subject"
                label="Subject"
                placeholder="Subject"
                onChange={this.handleChange}
              />
              <strong>Message</strong>
              <Form.Field>
                <TextArea
                  name="message"
                  value={this.state.message}
                  onChange={this.handleInputChange}
                  rows={15}
                />
              </Form.Field>
              <Button type="submit">Submit</Button>
            </Form>
          </Segment>
        </Modal.Content>
        <Modal.Actions></Modal.Actions>
      </Modal>
    );
  }
}

export default ApplicantsSendEmail;
